import { useMemo } from 'react';
import type { MinifiedAccountUser } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { UsersApi } from 'api';
import { DISPENSARY_USERS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useDispensaryUsers(dispensaryId: string) {
  const usersApi = new UsersApi();
  const { userBankId } = useUser();

  const {
    data: dispensaryUsers,
    isLoading: isLoadingDispensaryUsers,
    isError: isDispensaryStaffError
  } = useQuery<MinifiedAccountUser[]>({
    enabled: !!dispensaryId.length || !!userBankId,
    queryKey: [DISPENSARY_USERS_KEY, userBankId, dispensaryId],
    queryFn: () => usersApi.getDispensaryUsers(userBankId, dispensaryId)
  });

  const { activeUsers, archivedUsers } = useMemo(() => {
    if (!dispensaryUsers) return { activeUsers: undefined, archivedUsers: undefined };

    return {
      activeUsers: dispensaryUsers.filter((u) => u.invitation_status !== 'archived'),
      archivedUsers: dispensaryUsers.filter((u) => u.invitation_status === 'archived')
    };
  }, [dispensaryUsers]);

  return { dispensaryUsers, activeUsers, archivedUsers, isLoadingDispensaryUsers, isDispensaryStaffError };
}
